import React from 'react'
import { Fade } from "react-awesome-reveal";
import styled from 'styled-components';


function ProjectCard(props) {
    const cardStyle = {
    };
  return (
    <div>
      <Fade className="mb-4">
        <div
          class="card p-4"
          style={{
            maxWidth: "340px",
            textAlign: "center",
            color: "#fff",
            cursor: "pointer",
          }}
        >
          <div class="row g-0 effect-image-1 zoom-effect-1">
            <div class="col-md-12 project-image-container" style={cardStyle}>
              <img
                src={props.src}
                class="img-fluid rounded-start project-image"
                alt="projectimage"
              />
              <div
                class="overlay-text-effect-3 overlay-text-2"
                style={{
                  display: "flex",
                  alignItems: "center",
                  border: "solid green",
                }}
              >
                <p class="card-text">
                  {props.desc}
                  <hr></hr>
                  <a
                    href={props.link}
                    class=""
                    style={{ color: "#fff", textDecoration: "none" }}
                  >
                    Launch Project 🚀
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
        <ProjectName>{props.name}</ProjectName>
      </Fade>
    </div>
  );
}

export default ProjectCard

export const ProjectName = styled.h4`
    margin: 1rem;
    text-align: center;
    color: white;
`